const INITIAL_STATE = {
  data: {},
  errors: {},

}

const RerunOptimization = (state = INITIAL_STATE, action) => {

  switch (action.type) {
  case 'RETURN_OPTIMIZATION_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'RETURN_OPTIMIZATION_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default RerunOptimization;